import axios from "axios";

import { IGetPendingBookingTotalParams, ITotalPendingBookingsByLocations } from "../../pages/dashboard/types";

export const getTotalPendingBookingsByLocations = async (params: IGetPendingBookingTotalParams): Promise<ITotalPendingBookingsByLocations> => {
    const response = await axios.post('/booking/dashboard/total/byLocations', params);
    return response.data;
};
